import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './MyDeals.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import loader from '../../../assests/loader.gif';
import Modal from 'react-bootstrap/Modal';
import API from '../../../Utils/Api';
import moment from 'moment/moment';
import { gettoastsuccess, gettoastwarning } from '../../../Utils/Common';
const options = [
    { label: 'All', value: '', image: '../assets/images/discounticn.webp' },
    { label: 'Pending', value: 0, image: '../assets/images/esdicn.webp' },
    { label: 'Redeemed', value: 1, image: '../assets/images/sddicn.webp' },
];
const MyDeals = () => {

    const [loading, setLoading] = useState(true);

    const [date_filter, setDate_filter] = useState('');
    const [pagination, setPagination] = useState('');
    const [deal, setDeal] = useState([]);

    const [inputs, setInputs] = useState({ customer_name: '' });


    useEffect(() => {
        document.title = `My Deals | Local Bells`;
        document.getElementById('bodywrap').className = 'nemydeal';


        let formData = new FormData();
        formData.append('business_id', '');
        formData.append('per_page', 10);
        formData.append('page', 1);
        var url = 'get_user_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {

                    // console.log('number ' + response.data.data.pagination.current_page)
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                    // console.log('success');
                    setInputs({
                        customer_name: response.data.data.customer_name,
                    });


                }
            }).catch(error => {
                setLoading(false);
            });

        const handleClickOutside = (event) => {
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);

    }, []);


    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };
    const [selected, setSelected] = useState('');
    const handleChange = (value) => {
        setLoading(true);
        setSelected(value);
        // console.log("testing " + event);

        let formData = new FormData();
        formData.append('business_id', '');
        formData.append('per_page', 10);
        formData.append('page', 1);
        formData.append('type', value);
        formData.append('date_filter', date_filter);
        var url = 'get_user_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                }
            }).catch(error => {
                setLoading(false);
            });

    };


    const handleFilter = (value) => {

        setLoading(true);
        setDate_filter(value);
        // console.log("testing " + event);


        let formData = new FormData();
        formData.append('business_id', '');
        formData.append('per_page', pagination.per_page);
        formData.append('page', pagination.current_page);
        formData.append('type', selected);
        formData.append('date_filter', value);
        var url = 'get_user_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    console.log('success');
                    setPagination(response.data.data.pagination);
                    setDeal(response.data.data.deal);

                }
            }).catch(error => {
                setLoading(false);
            });

    };


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [selectedDealId, setSelectedDealId] = useState(null);

    const handleYes = (e) => {
        // console.log('testing' + selectedDealId);

        e.preventDefault();

        let formData = new FormData();
        formData.append('deal_clipped_id', selectedDealId);
        API.post('deal_clipped_status_change_by_user', formData)
            .then(response => {
                if (response.data.status === false) {
                    //setError(response.data.message);
                    setLoading(false);
                    setShow(false)
                    gettoastwarning(response.data.message, '');
                } else {
                    setLoading(false);
                    setShow(false)

                    setDeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_clipped_id === selectedDealId
                                ? {
                                    ...deal,
                                    redeem_status: 1,
                                }
                                : deal
                        )
                    );

                    gettoastsuccess(response.data.message, '');
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    };

    const getDeal = () => {
        setLoading(true);

        var currentpage = pagination.current_page + 1;
        let formData = new FormData();
        formData.append('business_id', '');
        formData.append('per_page', pagination.per_page);
        formData.append('page', currentpage);
        formData.append('type', selected);
        formData.append('date_filter', date_filter);
        var url = 'get_user_deal';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    // console.log('success');
                    setPagination(response.data.data.pagination);
                    // setDeal(response.data.data.deal);

                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);

                }
            }).catch(error => {
                setLoading(false);
            });
    }


    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={12} className='date-top'>
                                        <h3>My Deals</h3>
                                        <div>
                                            <h6><span className='fw-600'>Customer Name</span> : {inputs.customer_name}</h6>
                                        </div>
                                    </Col>
                                    <Col md={12} className='mdeal-top'>
                                        <div className=''>
                                            <div className="">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sort.webp'} className="img-fluid deal-sort-icn" alt="sort" />
                                                    <div className='d-flex deal-filter-box'>
                                                        {options.map((option) => {
                                                            const isSelected = selected === option.value;
                                                            //const isNotAll = option.value !== 'option1';
                                                            const isActive = isSelected;
                                                            return (
                                                                <label
                                                                    key={option.value}
                                                                    className={isActive ? 'active' : ''}
                                                                >

                                                                    <Button
                                                                        variant={isSelected ? 'act' : 'gen'}
                                                                        className={isActive ? 'active' : ''}
                                                                        onClick={() => handleChange(option.value)}
                                                                    >
                                                                        {option.label}
                                                                    </Button>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='date-filter'>
                                                <Dropdown onSelect={handleFilter}>
                                                    <Dropdown.Toggle variant="success" id="filter">
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/leicn.webp'} className="img-fluid" alt="leicn" />
                                                        <h6>Current Month</h6>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='date-drop'>
                                                        <Dropdown.Item eventKey="current_month" >Current Month</Dropdown.Item>
                                                        <Dropdown.Item eventKey="6_month">6 Months</Dropdown.Item>
                                                        <Dropdown.Item eventKey="1_year">1 Year</Dropdown.Item>
                                                        <Dropdown.Item eventKey="all_time">All time</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {deal.map((val, index) => {
                                    return (
                                        <div className='mdeal-single' key={index}>
                                            <div className='mds-top'>
                                                <h6>Deal ID : <span className='fw-600'>#{val.deal_unique_id}</span></h6>
                                                
                                               <h6 >Business Contact : <span className='fw-600'>{val.contact_number}</span></h6>
                                            </div>
                                            <div className='mds-bot'>
                                                <Row>
                                                    <Col xs="auto">
                                                        <Image src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} className="img-fluid" alt="md1" />
                                                    </Col>
                                                    <Col className='mds-mid-cont'>
                                                        <Link to={`/neighbour/clipped-deal/${val.deal_clipped_id}`}><h4>{val.listing_title}</h4></Link>
                                                        <div>
                                                            {/* <h6>Deal Details : <span className='fw-600'>₹ 1700</span></h6> */}
                                                            {/* <h6 className='strike'>₹2,500</h6> */}

                                                            {(() => {
                                                                if (val.deal_master_type === 'specific') {
                                                                    if (val.deal_type === 1) {
                                                                        return (<><h6>Deal Details :</h6><strike className="me-2"><h6>Rs. {val.original_mrp}</h6></strike><h6>Rs. {val.sale_price}</h6><h6 class="peroff">{val.discount}% off</h6>
                                                                        </>)
                                                                    } else if (val.deal_type === 2) {
                                                                        return (<><h6>Deal Details :</h6><h6>Buy {val.buy_qty} Get {val.get_qty}</h6>
                                                                        </>)
                                                                    }
                                                                } else if (val.deal_master_type === 'general') {
                                                                    if (val.deal_type === 3) {
                                                                        return (<><h6>Deal Details :</h6><h6>{val.store_percent_discount}% OFF</h6>
                                                                        </>)
                                                                    } else if (val.deal_type === 4) {
                                                                        return (<><h6>Deal Details :</h6><h6>{val.store_cash_discount} OFF</h6>
                                                                        </>)
                                                                    }
                                                                } else if (val.deal_master_type === 'free') {
                                                                    return (<><h6>Deal Details :</h6><h6 className="text-danger">FREE Shaving</h6>
                                                                    </>)
                                                                }
                                                            })()}
                                                        </div>
                                                        <div>
                                                            <p>Coupon Code : <span className='fw-500'>#{val.coupon_code}</span></p>
                                                            <p>Date of Purchased  : <span className='fw-500'>{moment(val.created_at).format("DD/MM/YY")}</span></p>
                                                            {val.redeemed_on && (<p>Redeemed on : <span className='fw-500'>{val.redeemed_on}</span></p>)}
                                                            {val.deal_end_date && (<p className='exp-date'>Expire on :  <span className='fw-500'>{moment(val.deal_end_date).format("DD/MM/YY")}</span></p>)}
                                                        </div>
                                                    </Col>
                                                    <Col xs="auto" className='mds-right'>
                                                        <h6>Marchant name : <Link to="/neighbour/clipped-deal"><span className='fw-600'>{val.business_name}</span></Link></h6>

                                                        {val.redeem_status !== 1 ? (<Link to="" onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedDealId(val.deal_clipped_id);
                                                            handleShow();
                                                        }}><h6 className='mds-dark'>Redeem</h6></Link>) : (<h6 className='mds-light'>Redeemed</h6>)}

                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    );
                                })}

                                {deal.length < pagination.total && (
                                    <Row className='text-center load-more'>
                                        <Col md={12}>
                                            <Link to="" onClick={getDeal} className='blue-link'>Load More</Link>
                                        </Col>
                                    </Row>)}
                                <div className='footer-main footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                        <Modal
                            show={show}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                            centered
                            className='redeem-modal'
                        >
                            <Modal.Body>
                                <Row>
                                    <Col md={12}>
                                        <h3 className='text-center'>Do you confirm to redeem the coupon?</h3>
                                    </Col>
                                    <Col md={6}>
                                        <Link to="" onClick={handleClose} className='grey-link'>No</Link>
                                    </Col>
                                    <Col md={6}>
                                        <Link to="" onClick={handleYes} className='blue-link'>Yes</Link>
                                    </Col>
                                </Row>
                            </Modal.Body>
                        </Modal>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default MyDeals;


